import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const IS_PROD = import.meta.env.PROD;

export function initGA() {
  if (!IS_PROD || !GA_MEASUREMENT_ID) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

/**
 * Registra un evento personalizado en Google Analytics 4.
 *
 * @param {string} action  - Nombre de la acción (e.g. "click_gestionar_pago")
 * @param {object} params  - Parámetros adicionales del evento (category, label, value, etc.)
 *
 * @example
 * trackEvent("click_gestionar_pago", { category: "Carrito", label: carritoUid });
 */
export function trackEvent(action, params = {}) {
  if (!IS_PROD || !GA_MEASUREMENT_ID) return;
  ReactGA.event(action, params);
}
